import * as Api from '@ViewModels';

function integrationUrl(accountId: string, provider: Api.IntegrationProvider): string {
	return `/accounts/${encodeURIComponent(accountId)}/integrations/${encodeURIComponent(provider)}`;
}

export function recentActivityUrl(accountId: string, provider: Api.IntegrationProvider): string {
	return `${integrationUrl(accountId, provider)}/recentActivity`;
}

/**
 * No tab segment: the integration page picks Setup over Settings itself for providers that have one and are
 * unconfigured, and naming a tab here suppresses that.
 */
export function setupUrl(accountId: string, provider: Api.IntegrationProvider): string {
	return integrationUrl(accountId, provider);
}
